export default "__VITE_ASSET__DB1O_Oyo__"